import { render, staticRenderFns } from "./MobileButton.vue?vue&type=template&id=2a4dc63f&"
import script from "./MobileButton.vue?vue&type=script&lang=js&"
export * from "./MobileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports